import { Action, ActionDefinition } from "components/actions/actions";
import { DataHolderComponent } from "components/components/Component";
import { DependencyCondition } from "components/restrictions/dependencies/Dependency";

export class EventActions {
    private actions: EventActionDefinition[];
    private dataHolder: DataHolderComponent;
    private intervals = [];
    constructor(
        actions: EventActionDefinition[],
        dataHolder: DataHolderComponent) {
        if (actions == null) {
            return;
        }
        this.actions = actions;
        this.dataHolder = dataHolder;
        for (const action of this.actions) {
            if (action.event.type === "pageClosed") {
                this.firePageClosedRegistrationEvent(
                    action,
                    dataHolder,
                );
            }
            if (action.event.type === "time") {
                this.intervals.push(setInterval(
                    () => {
                        this.run(action.action);
                    },
                    action.event.frequency));
            }
        }
    }

    private firePageClosedRegistrationEvent(action, dataholder) {
        let e = new CustomEvent(
            "pageCloseSuscribe",
            {
                bubbles: true,
                detail: {
                    action,
                    dataholder,
                },
            });
        setTimeout(() => this.dataHolder["view"].dispatchEvent(e), 0);
    }

    public unbind() {
        for (const interval of this.intervals) {
            clearInterval(interval);
        }
    }

    public onChange(property: any, newValue: any, component: any) {
        if (this.actions == null) {
            return;
        }
        for (const action of this.actions) {
            if (action.event.type === "change") {
                this.run(action.action);
            }
        }
    }

    private run = (actionDefinition: ActionDefinition) => {
        let data: any;
        data = this.dataHolder.selectDataForAction(actionDefinition);
        new Action(actionDefinition, this.dataHolder).run(data, this.dataHolder);
    }
}

export interface EventActionDefinition {
    event: {
        type: "change" | "click" | "time" | "blur" | "pageClosed";
        // targetComponent?: string;
        condition?: DependencyCondition;
        frequency?: number;
    };
    action: ActionDefinition;
}
